export const productRoutes = {
	products: (query: string) => `/products/${query ? `?${query}` : ''}`,
	product: (id: string) => `/products/${id}/`,
	productHistory: (id: string) => `/products/${id}/history/`,
	productDelete: (id: number | null) => `/products/${id}/`,
	productsDelete: '/products/bulk_delete/',
	productsShopify: '/products/sync_shopify/',
	productsPublish: '/products/make_published/',
	productsUnpublish: '/products/make_unpublished/',
	productsPrint: '/products/print_labels/',
	productsExport: '/products/export/',
	productsRegla: '/products/resync_with_regla/',
	productConfirm: (id: string) => `/products/${id}/make_confirmed/`,
	productUnconfirm: (id: string) => `/products/${id}/make_unconfirmed/`,
	productsConfirm: `/products/make_confirmed/`,
	productsUnconfirm: `/products/make_unconfirmed/`
} as const
